import { render, staticRenderFns } from "./TabsNavIcons.vue?vue&type=template&id=2e038fd7&"
import script from "./TabsNavIcons.vue?vue&type=script&lang=ts&"
export * from "./TabsNavIcons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports